// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"d3d2e963","379":"76b9e3ac"}[chunkId] + ".chunk.js";
};